import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const ShieldIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-shield${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M7.99997 2C9.55719 3.37772 11.5896 4.09504 13.6666 4C13.969 5.02868 14.0616 6.10764 13.9387 7.17279C13.8159 8.23793 13.4802 9.26751 12.9516 10.2004C12.423 11.1332 11.7122 11.9503 10.8616 12.603C10.011 13.2557 9.03783 13.7308 7.99997 14C6.96211 13.7308 5.98896 13.2557 5.13833 12.603C4.28771 11.9503 3.57698 11.1332 3.04837 10.2004C2.51976 9.26751 2.18406 8.23793 2.06122 7.17279C1.93838 6.10764 2.03091 5.02868 2.3333 4C4.41032 4.09504 6.44275 3.37772 7.99997 2Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default ShieldIcon;
